





































































































import { Component, Mixins } from "vue-property-decorator";
import StatsCurrencyMixin from "@/mixins/statsCurrencyMixin";
import { IClient } from "@/models/clients";
import { IsActiveParam } from "@/data/filters/contractProducts";
import { TicketStatusCodes as TSC } from "@/data/enums/tickets";

@Component({
  components: {
    "recent-invoices-list": () =>
      import("@/components/app/global/invoices/recentInvoicesList.vue"),
    "recent-tickets-list": () =>
      import("@/components/app/global/tickets/recentTicketsList.vue"),
    "invoices-total": () =>
      import("@/components/app/global/stats/invoicesTotal.vue"),
    "invoices-total-unpaid": () =>
      import("@/components/app/global/stats/invoicesTotalUnpaid.vue"),
    "total-orders": () =>
      import("@/components/app/global/stats/ordersTotal.vue"),
    "tickets-open": () =>
      import("@/components/app/global/stats/ticketsOpen.vue"),
    "cprods-provider": () =>
      import("@/components/app/global/contractProducts/cProdsProvider.vue"),
    "cprod-well-link": () =>
      import("@/components/app/global/contractProducts/cProdWellLink.vue"),
    "cprods-onboarding": () =>
      import("@/components/app/global/contractProducts/cProdsOnboarding.vue")
  }
})
export default class ClientInvoices extends Mixins(StatsCurrencyMixin) {
  public get clientId(): IClient["id"] {
    return this.$store.state.user.id;
  }
  public currencyCode: string | null = null;
  public readonly ticketsListProps = {
    limit: 4,
    statuses: [
      TSC.OPEN,
      TSC.IN_PROGESS,
      TSC.AWAITING_RESPONSE,
      TSC.CLIENT_REPLIED
    ]
  };

  public async created() {
    this.currencyCode = await this.getStatsDefaultCurrencyCode();
  }

  public get productsTitle() {
    return this.$t(
      this.$store.getters["ui/isMobile"]
        ? "_.active_products"
        : "_.active_products_and_services"
    );
  }

  public get cProdFilters() {
    return IsActiveParam();
  }
}
